import { useState } from 'react';

export default function useModal() {
  const [display, setDisplay] = useState(false);
  const handleOpen = () => setDisplay(true);
  const handleClose = () => setDisplay(false);

  return { handleOpen, handleClose, display };
}
